import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCheck, faEye, faEyeSlash, faUnlockKeyhole, faXmark} from '@fortawesome/free-solid-svg-icons';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../../services/api.service';
import {validateAllFormFields} from '../../../../common/utils';

@Component({
    selector: 'app-forgot-password-confim',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
    templateUrl: './forgot-password-confim.component.html',
    styleUrl: './forgot-password-confim.component.css'
})
export class ForgotPasswordConfimComponent implements OnInit{
  forgotPasswrdConfirmForm: FormGroup;
  token: string | null = null;
  isPasswordVisible: boolean = false;
  isPassword:boolean = false;
  isPasswordsMatch:boolean = false;

  constructor(private http: HttpClient,
              private router: Router,
              library: FaIconLibrary,
              private apiService: ApiService, 
              fb: FormBuilder,
              private toastr:ToastrService,
              private route: ActivatedRoute
            ) {
    library.addIcons(faUnlockKeyhole,
                    faEye, 
                    faEyeSlash,
                    faCheck,
                    faXmark
    )

    this.forgotPasswrdConfirmForm = fb.group({
      newPassword: ['',  [Validators.required,
                          Validators.minLength(8),
                    ]],
      confirmPassword: ['',  [Validators.required,
                        Validators.minLength(8),
                      ]],
      token: ['']

    });

    // Add password match validation
    this.forgotPasswrdConfirmForm.valueChanges.subscribe(() => {
      const newPass = this.forgotPasswrdConfirmForm.get('newPassword')?.value;
      const confirmPass = this.forgotPasswrdConfirmForm.get('confirmPassword')?.value;
      this.isPassword = newPass && confirmPass
      this.isPasswordsMatch = newPass && confirmPass && newPass === confirmPass;
      
    });
    
  }

  ngOnInit() {
    // Get the token from query parameters
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      if (!this.token){
        this.toastr.error('No token found', 'Error');
      }
    });
  }
  
  get newPassword(){
    return this.forgotPasswrdConfirmForm.get('newPassword');
  }
  get confirmPassword(){
    return this.forgotPasswrdConfirmForm.get('confirmPassword');
  }

  onSubmit(){
    
    if (this.forgotPasswrdConfirmForm.valid) {
      let formdata = new FormData();
      this.forgotPasswrdConfirmForm.value.token = this.token
      formdata.append('new_password', this.forgotPasswrdConfirmForm.value.newPassword);
      formdata.append('confirm_password', this.forgotPasswrdConfirmForm.value.confirmPassword);
      formdata.append('token',this.forgotPasswrdConfirmForm.value.token);


      this.apiService.forgotPasswordConfirm(formdata).subscribe({
        next: (res: any) => {
          this.toastr.success(res['detail'], 'Success');
          this.router.navigate(['/login']);
        },
        error: (err) => {
          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }
          if(err['error']['detail']) {
            this.toastr.error(err['error']['detail'], 'Error');
          } else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error("Something went wrong!", 'Error');
          }
        }
      })
    } else{
      validateAllFormFields(this.forgotPasswrdConfirmForm);
    }
  }
  togglePasswordVisibility(){
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  login(){
    this.router.navigate(['login'])
  }
}
